import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../auth/useAuthContext';
import BaseHeader from '../../shared/Header';
import Sidebar from '../../shared/Sidebar';
import { analyticsPages } from '../../app/routes/routes';
import Loader from '../../shared/Loader';

const withAnalyticsLayout = (WrappedComponent: any) => ({ ...props }) => {
  const { state, filterLinksWithAccess, isAdmin } = useContext(AuthContext);

  return (
    <div className="c-dashboard">
      <Sidebar/>
      {state.switchingBusiness ? <Loader/> :
        <section className="c-dashboard__layout">
          <div className="c-dashboard__container">
            <BaseHeader title="Analytics" />
            <nav className="settings-tab__nav">
              <ul className="settings-tab__list">
                {filterLinksWithAccess(analyticsPages).map(({title, path}) => {
                  return (
                    <li key={title} className="settings-tab__item">
                      <NavLink exact to={path} className="settings-tab__link">
                        {title}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </nav>
            <div className={`settings-tab__content ${!isAdmin() ? 'mt-4' : ''}`}>
              <WrappedComponent {...props} />
            </div>
          </div>
        </section>
      }
    </div>
  );
};

export default withAnalyticsLayout;
